import { translate } from '@manomano-internal/i18n/esm/placeholders';
export const {
  payLater,
  differedPayment
} = translate({
  "payLater": "Commandez maintenant. Payez plus tard.",
  "differedPayment": "Paiement diff\xE9r\xE9 \xE0 30 jours avec"
});